import SitePhoto from '@/components/Photo'
import type { SectionOf } from './shared'

export default function BannerSection({ section }: { section: SectionOf<'banner'> }) {
  const [first, ...rest] = section.lines
  if (section.photo) {
    return (
      <>
        <h2 className="sr-only">{section.lines.join(' ')}</h2>
        <SitePhoto
          photo={section.photo}
          sizes="(min-width: 1280px) 1152px, 100vw"
          className="w-full"
        />
      </>
    )
  }
  return (
    <div className="flex min-h-[200px] items-center justify-center rounded-[40px] bg-[linear-gradient(90deg,#7b7ce8_0%,#a98de8_55%,#dea4e7_100%)] px-8 py-14 text-center sm:min-h-[260px]">
      <h2 className="text-4xl uppercase leading-[1.05] tracking-[0.08em] text-white sm:text-5xl lg:text-6xl">
        <span className="block font-extrabold">{first}</span>
        {rest.map((line) => (
          <span key={line} className="block font-normal">
            {line}
          </span>
        ))}
      </h2>
    </div>
  )
}
